import { matchPath } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import classnames from 'classnames'
import { getCurrentPath } from '../../../helpers/browser'
import { PATH_HELPERS } from '../../../constants/navigation'
// Components
import FooterText from './FooterText/FooterText'
import Disclaimer from '../../shared/Disclaimer'
import HousingType from '../../shared/HousingType'
import { Text } from '../..'
// Styles
import styles from './HomeSearchFooter.module.scss'
import { StateSpecificFooterLinks } from '../Compliance/StateSpecificFooterLinks'

export const HomeSearchFooter = () => {
  const isListings = !!matchPath(getCurrentPath(), {
    path: PATH_HELPERS.listings.matchPath,
  })

  const DisclaimersHeadingText = () => (
    <Text
      element='h2'
      size='l'
      variant='neutralCool'
      variantCount='900'
      weight='bold'
      align='left'
      className={styles.heading}
    >
      <FormattedMessage
        id='HomeSearch.footer.disclaimers'
        defaultMessage='Disclaimers'
      />
    </Text>
  )

  return (
    <footer className={classnames(styles.root)}>
      <div>
        <hr />
        {isListings && (
          <div className={isListings ? styles.rail : ''}>
            <DisclaimersHeadingText />
          </div>
        )}
        <div className={!isListings ? styles.twoColumn : ''}>
          <div className={styles.leftColumn}>
            <Disclaimer
              className={classnames(isListings && styles.disclaimer)}
              staticContext={undefined}
            />
            <StateSpecificFooterLinks align='left' />
          </div>
          <div
            className={`${styles.rightColumn} ${isListings ? styles.rail : ''}`}
          >
            <HousingType className={styles.housingType} />
            <FooterText className={styles.footerText} />
          </div>
        </div>
      </div>
    </footer>
  )
}
